import { fetchRequestPrev } from "@providers/conect_prev";
import { fetchRequest } from "@providers/conect";

const verHorasApi = async ( data ) => {
  try {
    const url = `integrations/previplan/consultar-horas-disponibles`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const verHorasJornadaApi = async ( data ) => {
  try {
    const url = `dgh/hora-turno-medico`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const verHorasOcupadasApi = async ( data ) => {
  try {
    const url = `agendawp/booked-hours`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verHorasApi, verHorasJornadaApi, verHorasOcupadasApi };
